import React, { JSX } from 'react';
import { FormConfig, TextAreaElement } from '../types/types';
import FormTextarea from './FormTextarea';

interface Props {
  config: TextAreaElement;
  keySuffix?: FormConfig['keySuffix'];
}

const TextareaWrapper = (props: Props): JSX.Element => {
  const {
    config: {
      tag,
      key,
      label,
      placeholder,
      boldLabel,
      showErrorIcon,
      disabled,
      disablePaste,
      type,
      onFocus,
      onBlur,
      rows,
      cols,
      subLabel,
      inCollapse,
      collapseInitiallyOpen
    },
    keySuffix
  } = props;

  return (
    <FormTextarea
      tag={tag}
      name={`${key}${keySuffix ?? ''}`}
      label={label}
      subLabel={subLabel}
      boldLabel={boldLabel}
      showErrors
      placeholder={placeholder}
      showErrorIcon={showErrorIcon}
      disabled={disabled}
      disablePaste={disablePaste}
      type={type}
      onFocus={onFocus}
      onBlur={onBlur}
      rows={rows}
      cols={cols}
      inCollapse={inCollapse}
      collapseInitiallyOpen={collapseInitiallyOpen}
    />
  );
};

export default TextareaWrapper;
